import {
  CLIENT_REPORT_REQUEST,
  CLIENT_REPORT_SUCCESS,
  CLIENT_REPORT_FAILURE
} from "actions/ClientReport/clientReportAction";

const initialState = {
  clientReportList: [],
  clientReportData: {},
};

export default function clientReportReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case CLIENT_REPORT_REQUEST:
      return {
        ...state
      };
    case CLIENT_REPORT_SUCCESS:
      return {
        ...state,
        clientReportList: action.payload
      };
    case CLIENT_REPORT_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    case 'CLIENTREPORTDATA':
      if (!action.payload) {
        return initialState;
      } else {
        return {
          ...state,
          clientReportData: action.payload
        };
      }

    default:
      return state;
  }
}